import { render, staticRenderFns } from "./gdEenterpriseDetail.vue?vue&type=template&id=0166f06d&scoped=true&"
import script from "./gdEenterpriseDetail.vue?vue&type=script&lang=js&"
export * from "./gdEenterpriseDetail.vue?vue&type=script&lang=js&"
import style0 from "./gdEenterpriseDetail.vue?vue&type=style&index=0&id=0166f06d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166f06d",
  null
  
)

export default component.exports